export default (...λs) => (value) => λs.reduce((value, λ) => λ(value), value)

export const composeObject = (object, λ) => {
  const entries = Object.entries(object)
  const composition = entries.reduce(
    (composition, [ property, value ]) => ({
      ...composition,
      ...λ(property, value) || {}
    }),
    {}
  )
  return composition
}



// WEBPACK FOOTER //
// ./src/helpers/compose.js